const NoShorts = ({ onRetry }: { onRetry?: () => void }) => {
  return (
    <div className="flex flex-col items-center justify-center h-[calc(100vh-72px)] w-full text-center space-y-4 bg-gray-100 my-auto p-4 overflow-hidden">
      {/* Message */}
      <h2 className="text-lg font-semibold text-gray-800">
        No Shots Available
      </h2>
      <p className="text-sm text-gray-600">
        We're sorry, but we couldn’t find any shots for you right now.
      </p>
    </div>
  );
};

export default NoShorts;
